var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"pa-0 ma-0"},[_c('heading'),_c('v-container',[_c('h2',{staticClass:"pl-3 mt-6"},[_vm._v("Agencies")]),_c('last-shop-item'),_c('banner-middle'),_c('h2',{staticClass:"pl-3 mt-6"}),_c('last-travel-item')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }